export async function executeCall(callback: ()=>Promise<any>) {
    const response = await callback();
    return response.data;
}